import { useState } from 'react'

import useModalContext from '@contexts/modalContext'
import { size } from '@styles/theme'
import styled from '@emotion/styled'

const Image = styled.img`
  width: 100%;
  // TODO: set the max height based on dimensions too
  max-height: ${size(55)};
  object-fit: cover;
  border-radius: 15px;
  opacity: 0;
`

// const normalizeRatio = (ratio) => {
//   let normalized = (ratio > 4/3) ? 4/3 : ratio
//   normalized = (ratio < 1/2) ? 1/2 : normalized
//   return normalized
// }

const ImageMedia = ({ image, panelWidth, height }) => {
  const [isLoaded, setIsLoaded] = useState(false)
  // const ratio = normalizeRatio(image.height/image.width)
  const { mediaViewer } = useModalContext()
  if (!image.width || !image.height) {
    return ''
  }

  return (
    <Image
      // NOTE: Maybe pass in more data/information/functions through state
      onClick={(e) => {
        e.stopPropagation()
        mediaViewer.open({ search: { media_type: 'image', uuid: image?.uuid } }, { state: { image } })
      }}
      className={isLoaded ? 'animation__easeload' : ''}
      onLoad={() => setIsLoaded(true)}
      src={image?.url}
      style={{
        width: '100%',
        // height: image.height/image.width*panelWidth,
        height,
        aspectRatio: (image.width && image.height) ? image.width/image.height : 'auto',
      }}
    />
  )
}

// const VideoMedia = ({ video, panelWidth }) => {
//   const [isLoaded, setIsLoaded] = useState(false)
//   const { mediaViewer } = useModalContext()

//   return (
//     <div
//       // NOTE: Maybe pass in more data/information/functinons through state
//       onClick={(e) => {
//         e.stopPropagation()
//         mediaViewer.open({ search: { media_type: 'video', uuid: video?.uuid } }, { state: { video } })
//       }}
//       style={{ position: 'relative', borderRadius: '15px', overflow: 'hidden', width: '100%' }}>
//       <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: '#6A23FF', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '100%', height: '2.5rem', width: '2.5rem', lineHeight: 0, opacity: 1, border: '3px solid white' }}>
//         <PiPlayFill size='1.25rem' />
//       </div>
//       <img
//         className={isLoaded && 'animation__easeload'}
//         onLoad={(e) => setIsLoaded(true)}
//         src={video?.thumbnail}
//         style={{
//           width: panelWidth,
//           height: normalizeRatio(video.height/video.width)*panelWidth,
//           objectFit: 'cover',
//         }}
//       />
//     </div>
//   )
// }

const PostMedia = ({ media, panelWidth }) => {
  const image = (media?.length > 0 && media?.[0]?.uuid) ? media?.[0] : null
  if (!image || !image.height || !image.width) return;

  // calculatedHeight
  const height = Math.floor((image.height/image.width)*panelWidth)

  return (
    <div style={{ maxHeight: size(55), height, width: panelWidth, borderRadius: 15, backgroundColor: 'rgba(255,255,255,0.05)' }}>
    {/* <div style={{ height, width: panelWidth, borderRadius: 15, backgroundColor: 'black' }}> */}
      <ImageMedia
        image={media[0]}
        panelWidth={panelWidth}
        height={height}
      />
    </div>
  )
}

export { PostMedia }